import React from 'react';
import { Field, FieldArray } from 'redux-form';
import { BooleanInput, LongTextInput } from 'react-admin';
import { FormDataConsumer } from 'react-admin';

import AdUnitRender from './AdUnitRender';
import CheckAdUnitRender from '../Helpers/CheckAdUnitRender';
import Targets from './Targets';

type Props = {
  index: number,
  item: string,
  record: any
};

const AdUnitTabAdvanced = (props: Props) => (
  <div style={{ padding: 20 }}>
    <Field
      component={BooleanInput}
      label="Inactive"
      name={`${props.item}.inactive`}
      source={`${props.item}.inactive`}
      style={{ width: '0' }} />
    <Field
      component={BooleanInput}
      label="Companion Ads"
      name={`${props.item}.companion_ads`}
      source={`${props.item}.companion_ads`}
      style={{ width: '160px' }} /><br />

    <FieldArray
      component={Targets}
      label="Targets"
      name={`${props.item}.targets`}
      source={`${props.item}.targets`} />

    <Field
      component={LongTextInput}
      label="Height Mapping"
      name={`${props.item}.height_mapping`}
      source={`${props.item}.height_mapping`} /><br />
    <span style={{ color: 'rgba(0, 0, 0, 0.298039)', fontSize: 12 }}>
      Example: [[728, 90], [320, 50], [0,0]]
    </span><br />

    <Field
      component={LongTextInput}
      label="Account Name"
      name={`${props.item}.account`}
      source={`${props.item}.account`} />
    <FormDataConsumer>
      {({ formData, ...rest }) => CheckAdUnitRender(formData) &&
        <div style={{ width: '100%', display: 'inline-block' }}>
          <div style={{ position: 'absolute', width: '50%' }}>
            <AdUnitRender
              attribute_name="pre_adunit_rendered"
              index={props.index}
              label="Pre AdUnit Render"
              prefix={props.item}
              record={props.record} />
          </div>
          <div style={{ marginLeft: '50%' }}>
            <AdUnitRender
              attribute_name="on_adunit_rendered"
              index={props.index}
              label="On AdUnit Render"
              prefix={props.item}
              record={props.record} />
          </div>
        </div>
      }
    </FormDataConsumer>
  </div>
);

export default AdUnitTabAdvanced;



// WEBPACK FOOTER //
// ./src/views/Components/Placements/Partials/AdUnitTabAdvanced.tsx